import { render, staticRenderFns } from "./DeptTree.vue?vue&type=template&id=d48e1c64&"
import script from "./DeptTree.vue?vue&type=script&lang=js&"
export * from "./DeptTree.vue?vue&type=script&lang=js&"
import style0 from "./DeptTree.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports